import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface MessageDialogData {
	title: string;
	message: string;
	note?: string;
	confirmText?: string;
	confirmStyle?: string;
	warningNote?: boolean;
	dialogTitleId?: string;
}

@Component({
	selector: 'app-message-dialog',
	templateUrl: './message-dialog.component.html',
	styleUrls: ['./message-dialog.component.scss'],
	standalone: false
})
export class MessageDialogComponent {
	public constructor (
		public dialogRef: MatDialogRef<MessageDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) public data: MessageDialogData
	) {
		this.data.dialogTitleId ??= MessageDialogComponent.getDialogTitleId();
	}

	// A small helper to open the dialog with all the correct typing
	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<MessageDialogData>
	): MatDialogRef<MessageDialogComponent, boolean> {
		const dialogTitleId = config?.data?.dialogTitleId ?? MessageDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, MessageDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `message-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public close () {
		this.dialogRef.close(null);
	}

	public confirm () {
		this.dialogRef.close(true);
	}
}
